import useGetExcelNumberFormat from '../../../../../../../../hooks/useGetExcelNumberFormat';

const ListAlphabetExcelFormat = ({ angka }) => {
  const back = useGetExcelNumberFormat(angka);
  return <>{back}</>;
};
export default ListAlphabetExcelFormat;
